module.exports = __webpack_public_path__ + "static/media/DSC_0021.4e37e1c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0021.jpg
// module id = 587
// module chunks = 0